// Template image path mappings with fallback strategy
const createAssetPath = (templateName: string): string => {
	// Priority order for asset loading:
	// 1. Plugin dist assets (for npm-installed plugins)
	// 2. Public assets folder (fallback)

	if (typeof window !== "undefined") {
		// In browser, prefer plugin dist assets
		return `/node_modules/@di-devs/richmenu-feature-plugin/dist/client/assets/richmenu-templates/${templateName}.png`;
	}

	// Fallback for SSR or when plugin assets aren't available
	return `/assets/richmenu-templates/${templateName}.png`;
};

// Export template image mappings
export const RICHMENU_TEMPLATE_IMAGES = {
	RICH_MENU_TEMPLATE_101: createAssetPath("RICH_MENU_TEMPLATE_101"),
	RICH_MENU_TEMPLATE_102: createAssetPath("RICH_MENU_TEMPLATE_102"),
	RICH_MENU_TEMPLATE_103: createAssetPath("RICH_MENU_TEMPLATE_103"),
	RICH_MENU_TEMPLATE_104: createAssetPath("RICH_MENU_TEMPLATE_104"),
	RICH_MENU_TEMPLATE_105: createAssetPath("RICH_MENU_TEMPLATE_105"),
	RICH_MENU_TEMPLATE_201: createAssetPath("RICH_MENU_TEMPLATE_201"),
	RICH_MENU_TEMPLATE_202: createAssetPath("RICH_MENU_TEMPLATE_202"),
	RICH_MENU_TEMPLATE_203: createAssetPath("RICH_MENU_TEMPLATE_203"),
	RICH_MENU_TEMPLATE_204: createAssetPath("RICH_MENU_TEMPLATE_204"),
	RICH_MENU_TEMPLATE_205: createAssetPath("RICH_MENU_TEMPLATE_205"),
	RICH_MENU_TEMPLATE_206: createAssetPath("RICH_MENU_TEMPLATE_206"),
	RICH_MENU_TEMPLATE_207: createAssetPath("RICH_MENU_TEMPLATE_207"),
	RICH_MENU_CUSTOM_TEMPLATE_201: createAssetPath(
		"RICH_MENU_CUSTOM_TEMPLATE_201",
	),
	RICH_MENU_CUSTOM_TEMPLATE_202: createAssetPath(
		"RICH_MENU_CUSTOM_TEMPLATE_202",
	),
} as const;

// Type for template image keys
export type RichmenuTemplateImageKey = keyof typeof RICHMENU_TEMPLATE_IMAGES;

// Utility function to get template image URL
export const getRichmenuTemplateImage = (
	templateName: string,
): string | undefined => {
	return RICHMENU_TEMPLATE_IMAGES[templateName as RichmenuTemplateImageKey];
};
